
import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../../commonFunctions";
  
  const perlon = {
    label: "Loan Period Range",
    pageLabel: "Loan Period Range",
    starting: true,
    url: "perlon",
    pageType: "history",
    form: [
        {
            inputType: "handsonTable",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            // headers:["Car", "Model", "Number", "Date"],
            // data:[],
            label: "Loan Period Range",
            name: "loanperiodrange",
            description: "none",
            tableOptions: {
              // validations, basic calculations, colors, date pickers, context menu etc.
              HOTheaders: [
                "Code",
                "From Number",
                "End Number",
                "Days",
                "Active"
              ],
              columns: [
                {},
                { type: "numeric"},
                {
                  type: "numeric"
                },
                {
                    data: "Checkbox", type: "checkbox" 
                },
                {
                    data: "Checkbox", type: "checkbox" 
                },
             
              ],
              rowHeaders: false,
              // contextMenu: true,
              minSpareRows: 4,
              stretchH: "last",
              // columnSorting: true,
              autoWrapRow: true,
              maxRows: 100,
            
            }
          },
    ]
}

export default perlon;